import { Box, IconButton, Typography } from "@mui/material";
import theme from "Theme/AppTheme";

const QuantityPill = ({
        count,
        onIncrement,
        onDecrement,
        disableIncrement = false,
    }: {
        count: number;
        onIncrement: () => void;
        onDecrement: () => void;
        disableIncrement?: boolean;
    }) => (
        <Box
            sx={{
                position: "absolute",
                top: theme.spacing(1),
                right: theme.spacing(1),
                backgroundColor: theme.palette.white.main,
                borderRadius: 999,
                border: `1px solid ${theme.palette.gray[200]}`,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                zIndex: 3,
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <IconButton
                size="small"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDecrement();
                }}
                sx={{ padding: theme.spacing(0.5) }}
            >
                -
            </IconButton>
            <Typography
                sx={{
                    px: 0.5,
                    minWidth: "16px",
                    textAlign: "center",
                    fontWeight: 600,
                    color: theme.palette.gray[900],
                }}
            >
                {count}
            </Typography>
            <IconButton
                size="small"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onIncrement();
                }}
                disabled={disableIncrement}
                sx={{ padding: theme.spacing(0.5) }}
            >
                +
            </IconButton>
        </Box>
    ); 

export default QuantityPill;